export const REFRESH_INTERVAL = 10 * 60 * 1000; // 10 minutes
export const MANUAL_REFRESH_COOLDOWN = 10 * 1000; // 10 seconds
